import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { rValue } from '../../models/.catalog';
import pOtpKontrol from '../../models/pOtpKontrol';
import rOtp from '../../models/rOtp';

export default class OtpKontrolApi extends ApiBase<pOtpKontrol, rValue<rOtp>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OtpKontrolEt',
      }),
      options
    );
    this._ServiceUrl = '/services/OyakExternal.asmx';
  }
}
